var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{class:['totem-link', _vm.size, _vm.color, {'-icon' : _vm.icon}],style:(_vm.cssVars),attrs:{"to":_vm.to}},[_c('span',{class:[_vm.iconPosition , 'totem-link__content']},[(_vm.icon)?_c('span',{class:'icon-' + _vm.icon}):_vm._e(),_c('span',{staticClass:"label",domProps:{"innerHTML":_vm._s(_vm.label)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }